import React from "react";
import {
    FileOutlined,
    DatabaseOutlined,
    UnorderedListOutlined,
} from "@ant-design/icons";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import { checkUserBD } from "../util/help";

const { SubMenu } = Menu;
export default function NavBarComponent({ routes }) {

    let history = useHistory();

    let user = localStorage.getItem('USER_NO')

    const menuBasicData = [
        {
            name: "Customers",
            to: "/Dasboard/khachhang",
            exact: true,
        },
        {
            name: "Staffs",
            to: "/Dasboard/nhanvien",
            exact: true,
        },
        {
            name: "Fee Kind Information",
            to: "/Dasboard/chiphi",
            exact: true,
        },
        {
            name: "Shipping carriers",
            to: "/Dasboard/hangtau",
            exact: true,
        },
        {
            name: "Nhà Xe",
            to: "/Dasboard/nhaxe",
            exact: true,
        },
        {
            name: "Đại Lý",
            to: "/Dasboard/daily",
            exact: true,
        },
        {
            name: "Người dùng",
            to: "/Dasboard/users",
            exact: true,
        },
    ];

    const menuQuanLyHoSo = [
        {
            name: "Job Cards Information",
            to: "/Dasboard/taophieutheodoi",
            exact: true,
        },
        {
            name: "Job Order Information",
            to: "/Dasboard/taojoborder",
            exact: true,
        },
        {
            name: "Job Order ( booking ship ) Information",
            to: "/Dasboard/taojobbooktau",
            exact: true,
        },
        {
            name: "Job Order Approval",
            to: "/Dasboard/duyetjoborder",
            exact: true,
        },
        {
            name: "Duyệt Cược Cont",
            to: "/Dasboard/duyetcuoccont",
            exact: true,
        },
        {
            name: "JOB CARD MANAGEMENT REPORTS",
            to: "/Dasboard/baobieuhoso",
            exact: true,
        },
    ];

    const menuQuanLyThuChi = [
        {
            name: "Advance payment Information",
            to: "/Dasboard/phieuchitamung",
            exact: true,
        },
        {
            name: "Debit note Information",
            to: "/Dasboard/yeucauthanhtoan",
            exact: true,
        },
        {
            name: "Payment approval",
            to: "/Dasboard/duyetthanhtoan",
            exact: true,
        },
        {
            name: "Checking data Information",
            to: "/Dasboard/tracuudulieu",
            exact: true,
        },
        {
            name: "Shipping Fee Information",
            to: "/Dasboard/chiphicuoctaucont",
            exact: true,
        },
        {
            name: "Receipt Information",
            to: "/Dasboard/phieuthu",
            exact: true,
        },
        {
            name: "RECEIPTS AND PAYMENT REPORTS",
            to: "/Dasboard/baobieuthuchi",
            exact: true,
        },
    ]

    const menuQuanLyHoSoBD = [
        {
            name: "Tạo Phiếu Theo Dõi",
            to: "/Dasboard/taophieutheodoi",
            exact: true,
        },
        {
            name: "Tạo Job Order",
            to: "/Dasboard/taojoborder",
            exact: true,
        },
        {
            name: "Tạo Job Book Tàu",
            to: "/Dasboard/taojobbooktau",
            exact: true,
        },
        {
            name: "Báo Biểu Hồ Sơ",
            to: "/Dasboard/baobieuhoso",
            exact: true,
        },
    ]

    const menuQuanLyThuChiBD = [
        {
            name: "Advance payment Information",
            to: "/Dasboard/phieuchitamung",
            exact: true,
        },
    ]

    const MenuItem = (menus) => {
        var result = null;
        if (routes.length > 0) {
            result = menus.map((menu) => {
                return (
                    <Menu.Item key={menu.to}>
                        <span>{menu.name}</span>
                        <Link to={menu.to} />
                    </Menu.Item>
                );
            });
        }
        return result;
    };

    return (
        <Menu mode="horizontal" theme='dark'
            defaultSelectedKeys={[history.location.pathname]}>
            {checkUserBD.indexOf(user.toString()) === -1 ? <>
                <SubMenu key="sub1" icon={<DatabaseOutlined />} title="BASICAL DATA">
                    {MenuItem(menuBasicData)}
                </SubMenu>
                <SubMenu
                    key="sub2"
                    icon={<UnorderedListOutlined />}
                    title="JOB CARDS MANAGEMENT"
                >
                    {MenuItem(menuQuanLyHoSo)}
                </SubMenu>
                <SubMenu key="sub3" icon={<FileOutlined />} title="RECEIPTS AND PAYMENT">
                    {MenuItem(menuQuanLyThuChi)}
                </SubMenu>
            </> : <>
                <SubMenu
                    key="sub1"
                    icon={<UnorderedListOutlined />}
                    title="JOB CARDS MANAGEMENT"
                >
                    {MenuItem(menuQuanLyHoSoBD)}
                </SubMenu>
                <SubMenu key="sub2" icon={<FileOutlined />} title="RECEIPTS AND PAYMENT">
                    {MenuItem(menuQuanLyThuChiBD)}
                </SubMenu>
            </>}


        </Menu>
    )
}